<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','background':field.temp_prop.hasOwnProperty('bg_color')&&field.temp_prop.bg_color.show?field.temp_prop.bg_color.value.hex:'#fff'}"
      > 
      <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
        <h5
            class="text-center invoice-top-heading"
            style="position:relative"
          >
            <span
              v-show="showprintlabel && printlabel != ''"
              style="position:absolute;right:0;padding:2px 4px;border:2px solid #929292;color:#000;margin-right:5px"
            >{{ printlabel }}</span>
          </h5>
           <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div style="word-break:break-word !important">
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >{{ org_details.comp_name }}</div>

              <div
                v-if="field.header_prop.show_org_addr"
                class="custom-invoice-address"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
              >
               <p>{{ org_details.addr_line_1 }}</p>
                <p>{{ org_details.addr_line_2 }}</p>
                <p>{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</p>
                <p>
                  {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                  {{ org_details.org_pincode }}
                </p>
                <p>{{field.header_prop.phone}}: {{ org_details.phone_no }}</p>
                <p v-if="field.header_prop.hasOwnProperty('fax')&&org_details.hasOwnProperty('fax_no')">{{field.header_prop.fax}}: {{org_details.fax_no}}</p>
                <p class="mb-0" href="mailto:#">{{ org_details.org_mail }}</p>
                <p
                  v-if="org_details.gst_type != 3 && org_details.gst_no != ''"
                  style="margin-bottom:0px;"
                >GSTIN: {{ org_details.gst_no }}</p>
              </div>
            </div>
            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo && org_details.org_logo != null && org_details.org_logo  != ''"
                v-bind:src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                style="max-width:300px;max-height:183.05px;padding-bottom:5px !important"
              />
            </div>
          </div>
           <hr />
           <div class="invoice-second-block" style="padding-bottom:20px">
               <div v-if="field.receipt_info.doc_title.show" style="text-align:center;word-break:break-word;" :style="{'font-size':field.receipt_info.doc_font_size+'pt'}">
                   <u style="color:rgba(0, 0, 0, 0.46) !important"><span :style="{'color':field.receipt_info.doc_font_color.hex}">{{field.receipt_info.doc_title.label}}</span></u>
               </div>
           </div>
           <div class="invoice-third-block" style="display:flex;padding-top:30px">
               <table style="width: 70%;float: left;">
                   <thead>
                           <th style="width:35%;float:left;"></th>
                           <th style="width:65%;"></th>
                   </thead>
                   <tbody>
                       <tr v-if="field.receipt_info.doc_no.show">
                           <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">{{field.receipt_info.doc_no.label}}</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{list.data.header_details.cus_adv_no||'-'}}</b></div></td>
                       </tr>
                       <tr v-if="field.receipt_info.doc_date.show">
                           <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">{{field.receipt_info.doc_date.label}}</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{getDateFormat(list.data.header_details.pymnt_date)||'-'}}</b></div></td>
                       </tr>
                       <tr v-if="field.receipt_info.doc_ref_no.show">
                           <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">{{field.receipt_info.doc_ref_no.label}}</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{list.data.header_details.ref_no||'-'}}</b></div></td>
                       </tr>
                       <tr v-if="field.receipt_info.doc_pymt_mode.show">
                           <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">{{field.receipt_info.doc_pymt_mode.label}}</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;" ><b>{{list.data.header_details.method_name||'-'}}</b></div></td>
                       </tr>
                       <tr>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">Place Of Supply</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ getDetails($AppDetails.state_details,list.data.header_details.place_of_supply,'state_name') }} ({{ list.data.header_details.place_of_supply }})</b></div></td>
                       </tr>
                       <tr v-for="item in tax_details" :key="item.id">
                         <td :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="word-break:break-word !important">{{item.label}}
                           <!-- <span>[{{ parseFloat(item.taxable_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}]</span> -->
                           </td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>  <div style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(item.value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                            </div>
                            </b></div></td>

                              </tr>
                       <tr  v-for="custom_field in cus_adv_settings_details.custom_field"
                            v-if="custom_field.print_show == 1 && custom_field.status == 1 && custom_field.permissions != 'hide' && list.data.header_details[custom_field.field_name]"
                            :key="custom_field.index">
                           <td style="word-break:break-word !important" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">{{custom_field.label_name}}</td>
                           <td
                           :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}"
                                  style="word-break:break-word !important"
                                  v-if="custom_field.datatype == 'select'"
                                ><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ getJsonPresentValue(custom_field.options,'value',list.data.header_details[custom_field.field_name],'label') }}</b></div></td>
                                <td
                                :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}"
                                  style="word-break:break-word !important"
                                  v-else-if="custom_field.datatype == 'date'"
                                ><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ getDateFormat(list.data.header_details[custom_field.field_name]) }}</b></div></td>
                                <td
                                :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}"
                                  style="word-break:break-word !important"
                                  v-else-if="custom_field.datatype == 'amount'"
                                ><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ orgCurrencySymbol +' '+list.data.header_details[custom_field.field_name] }}</b></div></td>
                                <td
                                :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}"
                                  style="word-break:break-word !important"
                                  v-else
                                ><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ list.data.header_details[custom_field.field_name] }}</b></div></td>
                       </tr>
                       <tr v-if="field.receipt_info.show_amt_wrd">
                           <td style="word-break:break-word !important" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">Amount Received In Words</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{ total_in_words+" Only" }}</b></div></td>
                       </tr>
                       <tr>
                           <td style="word-break:break-word !important" :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}">Description of supply</td>
                           <td :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="word-break:break-word !important"><div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;"><b>{{list.data.header_details.desc_of_supply||'-'}}</b></div></td>
                       </tr>
                   </tbody>
               </table>
               <table style="width: 30%;" >
                   <tbody>
                       <tr>
                           <td style="word-break:break-word !important">
                              <div :style="{'color':field.receipt_info.amt_recv_font_color.hex,'background':field.receipt_info.amt_recv_bg_color.show?field.receipt_info.amt_recv_bg_color.value.hex:'#fff'}" style="text-align:center;word-break: break-word;float:right;padding: 34px 15px;">
                                    <span   :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}">{{field.receipt_info.amt_recv_label}}</span><br>
                                    <span :style="{'font-size':field.receipt_info.amt_recv_font_size+'pt'}" style="display:inline-block"><span
                                    style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>
                                    {{parseFloat(list.data.header_details.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                                    </span>
                                </div>
                           </td>
                       </tr>
                   </tbody>
               </table>
           </div>
        <div class="invoice-fourth-block" style="display: flow-root;">
              <div class="signature-block">
                <div style="float:right;width:max-content" v-if="field.receipt_info.signature.show">
                  <div style="word-break:break-word !important"
                    class="semi-bold text-right mb-2"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 2.5rem" />
                </div>
                <div
                  style="float:left;width:max-content"
                  v-if="field.receipt_info.hasOwnProperty('add_signature')&&field.receipt_info.add_signature.show"
                >
                  <div
                    class="semi-bold text-right mb-2"
                    style="word-break:break-word !important"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.add_signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 2.5rem" />
                </div>
              </div>
            </div>
        <div class="invoice-third-block" style="padding-top:30px;word-break:break-word !important" v-if="field.receipt_info.cus_recv_from.show">
                <p :style="{'color':field.temp_prop.label_color.hex}"><b>{{field.receipt_info.cus_recv_from.label}}</b></p>
                <b :style="{'font-size':field.receipt_info.bill_addr_font_size+'pt','color':field.receipt_info.bill_addr_font_color.hex}">{{ list.data.header_details.cus_name }}</b>
                                <template
                                  v-if="typeof list.data.payment_details_address[1] !== 'undefined'"
                                >
                                  <p
                                    style="margin:0px"
                                  >{{ list.data.payment_details_address[1].cus_addr_line_1 }}</p>
                                  <p
                                    style="margin:0px"
                                  >{{ list.data.payment_details_address[1].cus_addr_line_2 }}</p>
                                  <p
                                    style="margin:0px"
                                  >{{ getDetails($AppDetails.state_details,list.data.payment_details_address[1].cus_state,'state_name') }}</p>
                                  <p
                                    style="margin:0px"
                                  >{{ getDetails($AppDetails.country_details,list.data.payment_details_address[1].cus_country,'country_name') }}</p>
                                </template>
                                <a
                                  class="text-decoration-none"
                                  href="mailto:#"
                                >{{ list.data.header_details.cus_mail }}</a>
                                <p style="margin:0px">
                                  <span>Ph:</span>
                                  {{ list.data.header_details.cus_ph_no_1 }}
                                </p>
                                <p
                                  style="margin:0px"
                                  v-if="list.data.header_details.cus_gst_type == 1 || list.data.header_details.cus_gst_type == 7 || list.data.header_details.cus_gst_type ==2  ||list.data.header_details.cus_gst_type == 4 "
                                >
                                  <span>GSTIN:</span>
                                  {{ list.data.header_details.cus_gst_no }}
                                </p>
        </div>
        <hr />
        <div class="invoice-fourth-block" style="padding-top:10px">
            <table>
                <tbody>
                    <tr>
                        <td  style="word-break:break-word !important" v-if="field.receipt_info.doc_pymt_refund.show">
                            <div style="border-right: 1px solid #ededed;padding-right:20px">
                            <p :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="font-size:13px;font-weight:bold">{{field.receipt_info.doc_pymt_refund.label}}</p>
                            <p :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="text-align:center"><span style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(list.data.header_details.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                            </span>
                            </p>
                            </div>
                        </td>
                        <td  style="word-break:break-word !important" v-if="field.receipt_info.doc_over_pymt.show">
                            <div>
                            <p :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}" style="font-size:13px;font-weight:bold">{{field.receipt_info.doc_over_pymt.label}}</p>
                            <p :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000'}" style="text-align:center"><span style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(list.data.header_details.excess_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                            </span>

                            </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr />
        <div class="invoice-fifth-block" v-if="field.inv_details.label.show_inv_detail&&list.data.invoice_details_payment.length>0">
            <p style="word-break:break-word !important" :style="{'color':field.inv_details.layout.pymt_font_color.hex,'font-size':field.inv_details.layout.pymt_font_size+'pt'}">{{field.inv_details.label.pymt_for_label}}</p>
            <table style="width:100%;border-collapse: collapse !important;" >
                <thead :style="{'background':field.inv_details.layout.header_bg_color.show?field.inv_details.layout.header_bg_color.value.hex:'#fff','color':field.inv_details.layout.header_font_color.hex,'font-size':field.inv_details.layout.header_font_size+'pt'}">
                        <th style="padding:5px 10px 5px 10px;word-break: break-word;text-align:left" v-if="field.inv_details.label.inv_no.show">{{field.inv_details.label.inv_no.label}}</th>
                        <th style="padding:5px 10px 5px 10px;word-break: break-word;text-align:left" v-if="field.inv_details.label.inv_date.show">{{field.inv_details.label.inv_date.label}}</th>
                        <th style="padding:5px 10px 5px 10px;word-break: break-word;text-align:right" v-if="field.inv_details.label.inv_amt.show">{{field.inv_details.label.inv_amt.label}}</th>
                        <th style="padding:5px 10px 5px 10px;word-break: break-word;text-align:right" v-if="field.inv_details.label.pymt_amt.show">{{field.inv_details.label.pymt_amt.label}}</th>
                </thead>
                <tbody :style="{'font-size':(field.inv_details.layout.item_row_font_size||8)+'pt','color':field.inv_details.layout.hasOwnProperty('item_row_font_color')?field.inv_details.layout.item_row_font_color.hex:'#000','background':field.inv_details.layout.hasOwnProperty('item_row_bg_color')&&field.inv_details.layout.item_row_bg_color.show?field.inv_details.layout.item_row_bg_color.value.hex:'#fff'}">
                    <tr :style="{'border-bottom':field.inv_details.layout.table_border.show+'px'+' solid '+field.inv_details.layout.table_border.value.hex}" v-for="item  in list.data.invoice_details_payment" :key="item.id">
                        <td style="padding:5px 10px 5px 10px;word-break: break-word;text-align:left" v-if="field.inv_details.label.inv_no.show">{{item.inv_no}}</td>
                        <td style="padding:5px 10px 5px 10px;word-break: break-word;text-align:left" v-if="field.inv_details.label.inv_date.show">{{ getDateFormat(item.created_date) }}</td>
                        <td style="padding:5px 10px 5px 10px;word-break: break-word;text-align:right" v-if="field.inv_details.label.inv_amt.show"><span style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>{{  parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                        <td style="padding:5px 10px 5px 10px;word-break: break-word;text-align:right" v-if="field.inv_details.label.pymt_amt.show"><span style="margin-left:5px !important;margin-right:5px !important" :class="{'float-right':field.receipt_info.currency_syb==2}"> {{currency_symbol}} </span>{{ parseFloat(item.pymnt_applied_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>       
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.hasOwnProperty('footer_color')?field.footer_prop.footer_color.hex:'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { number_to_words } from "@/mixins/NumberToWords";
export default {
  props: ["list","tax_details"],
  data() {
    return {
      total_in_words: "",
      imageSrc: "",
      tax_list: "",
      currency_symbol: ""
    };
  },
  
  created() {
     this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.data.header_details.cus_currency,
      "currency_symbol"
    );
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.data.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.data.header_details.received_amount,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.data.header_details.cus_currency,
          "currency_code_fraction"
        )
      );

    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    }
  },
  mounted() {
    //    customer currency symbol
    // this.currency_symbol = this.getDetails(
    //   this.$AppDetails.currency_details,
    //   this.list.invoice_header_detail.cus_currency,
    //   "currency_symbol"
    // )
  },
  computed: {
    ...mapState({
      field: state =>
        state.permission.print_settings_details["Customer Advance"].template_list
    }),
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "cus_adv_settings_details","orgCurrencySymbol"])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
</style>
